/* eslint-disable */
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../../services/Axios/axios";
import RenderITOfficerPage from "../RenderITOfficerPage";
import UploadCard from "../components/UploadCard";

function UploadLoans() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const handleUpload = async (file) => {
    setIsLoading(true);
    setResponse(null);
    try {
      const formData = new FormData();
      formData.append("file", file);
      await axiosInstance.post("/loans/upload", formData);
      setResponse({ state: "SUCCESS", message: "Loans uploaded successfully. Processing in background." });
      toast.success("Loans uploaded successfully");
    } catch (e) {
      const msg = e?.response?.data?.message ?? "Upload failed. Try again.";
      setResponse({ state: "ERROR", message: msg });
      toast.error(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <RenderITOfficerPage title="Upload Loans">
      <UploadCard
        title="Upload Loan Deductions"
        description="Upload an Excel or CSV file containing loan deduction records."
        onUpload={handleUpload}
        isLoading={isLoading}
        response={response}
        accentColor="blue"
      />
      <ToastContainer autoClose={3000} />
    </RenderITOfficerPage>
  );
}

export default UploadLoans;
